import { Link } from "react-router-dom";
import SEO from "@/components/site/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found | UKTDA" description="The page you are looking for could not be found." path="/404" />
      <section className="py-32 container-rail text-center" data-testid="not-found-page">
        <p className="label-eyebrow text-safety">404</p>
        <h1 className="mt-4 font-display font-bold text-4xl md:text-5xl text-navy">Page not found</h1>
        <p className="mt-4 text-slate-600 max-w-md mx-auto">The route you followed has been changed, or never existed. Let&rsquo;s get you back on track.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 bg-safety hover:bg-[#e66e00] text-white font-semibold px-5 py-3 rounded-md transition-colors">
          Return home
        </Link>
      </section>
    </>
  );
}
